import React, { useState } from "react";
import { Lock } from "lucide-react";
import { axios, API } from "../lib/api";
import { useAuth } from "../auth/AuthProvider";

export const ParentalGate = ({ onVerify, onCancel, title = "Parent Verification Required" }) => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  const handleVerify = async () => {
    if (pin.length !== 4) { setError("Please enter a 4-digit PIN"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/verify-pin`, { pin }, { headers: { Authorization: `Bearer ${token}` } });
      onVerify(pin);
    } catch { setError("Invalid PIN. Please try again."); }
    finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="parental-gate">
      <div className="brutalist-card p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-[#FF6B6B] rounded-full flex items-center justify-center mx-auto mb-4 border-2 border-gray-900 shadow-[4px_4px_0px_0px_rgba(17,24,39,1)]">
          <Lock className="w-8 h-8 text-white" />
        </div>
        <h2 className="text-2xl font-black mb-2" style={{ fontFamily: 'Outfit' }}>{title}</h2>
        <p className="text-gray-600 mb-6">A parent or guardian needs to enter the 4-digit PIN to continue.</p>
        <div className="flex justify-center gap-2 mb-4">
          {[0,1,2,3].map(i => (
            <input
              key={i}
              type="password"
              maxLength={1}
              value={pin[i] || ""}
              onChange={(e) => {
                const newPin = pin.split('');
                newPin[i] = e.target.value;
                setPin(newPin.join('').slice(0, 4));
                if (e.target.value && e.target.nextSibling) e.target.nextSibling.focus();
              }}
              className="w-14 h-14 text-center text-2xl font-bold brutalist-input"
              data-testid={`pin-input-${i}`}
            />
          ))}
        </div>
        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
        <div className="flex gap-3">
          <button onClick={onCancel} className="brutalist-btn-secondary flex-1">Cancel</button>
          <button onClick={handleVerify} disabled={loading} className="brutalist-btn-primary flex-1" data-testid="verify-pin-btn">
            {loading ? "Verifying..." : "Verify"}
          </button>
        </div>
      </div>
    </div>
  );
};
